"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerContainer = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SpinnerContainer = (0, _styledComponents["default"])(function (_ref) {
  var color = _ref.color,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["color"]);
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, other);
})(_templateObject(), function (props) {
  return props.color;
});
exports.SpinnerContainer = SpinnerContainer;